import { ArrowRight } from "lucide-react";

export const Hero = () => (
  <section
    id="top"
    aria-labelledby="hero-title"
    className="relative min-h-[calc(100svh-4.5rem)] overflow-hidden bg-paper"
    data-testid="hero-section"
  >
    <img
      src="/images/hero-original.webp"
      alt="Nybyggd altan i trä med utsikt över åkrar, björkar och en sjö i höstljus"
      className="absolute inset-0 h-full w-full object-cover contrast-[1.03] saturate-[1.02]"
      style={{ objectPosition: "58% 42%" }}
      fetchPriority="high"
      decoding="sync"
      data-testid="hero-image"
    />

    {/* One continuous full-width veil: no visible edge between text zone and photo. */}
    <div
      className="pointer-events-none absolute inset-0 lg:hidden"
      style={{
        background:
          "linear-gradient(90deg, rgba(251,249,245,0.995) 0%, rgba(251,249,245,0.985) 44%, rgba(251,249,245,0.91) 60%, rgba(251,249,245,0.72) 73%, rgba(251,249,245,0.46) 84%, rgba(251,249,245,0.20) 94%, rgba(251,249,245,0.04) 100%)",
      }}
      aria-hidden="true"
    />
    <div
      className="pointer-events-none absolute inset-0 hidden lg:block"
      style={{
        background:
          "linear-gradient(90deg, rgba(251,249,245,1) 0%, rgba(251,249,245,0.995) 20%, rgba(251,249,245,0.96) 32%, rgba(251,249,245,0.84) 44%, rgba(251,249,245,0.61) 55%, rgba(251,249,245,0.36) 65%, rgba(251,249,245,0.17) 75%, rgba(251,249,245,0.055) 84%, rgba(251,249,245,0) 92%)",
      }}
      aria-hidden="true"
    />

    <div className="relative z-10 mx-auto box-border min-h-[calc(100svh-4.5rem)] w-full max-w-[1440px] px-5 pb-24 pt-10 sm:px-8 sm:pb-28 sm:pt-14 lg:px-12 lg:pb-32 lg:pt-16 xl:pt-20">
      <div className="w-full max-w-[500px]">
        <p className="eyebrow text-ink/80">Byggföretag i Avesta & Hedemora</p>

        <h1
          id="hero-title"
          className="mt-5 font-display text-[2.75rem] font-normal leading-[0.98] tracking-tight text-ink sm:text-[4rem] lg:text-[4.6rem]"
          data-testid="hero-title"
        >
          Byggt med erfarenhet.
          <br />
          <span className="italic text-moss">Utfört med omsorg.</span>
        </h1>

        <p
          className="mt-6 max-w-[455px] text-base leading-relaxed text-ink sm:text-lg"
          data-testid="hero-subtext"
        >
          Renovering, ombyggnad och tillbyggnad i Avesta och Hedemora med omnejd.
          Beskriv ditt projekt direkt till Lars så återkommer han.
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a href="#kontaktformular" className="btn-primary" data-testid="hero-cta-offert">
            Beskriv ditt projekt
            <ArrowRight size={18} strokeWidth={1.75} className="arrow" aria-hidden="true" />
          </a>
          <a
            href="#projekt"
            className="btn-ghost bg-paper/88 backdrop-blur-[1px]"
            data-testid="hero-cta-projekt"
          >
            Se våra arbeten
          </a>
        </div>

        <p className="mt-9 text-[0.8rem] font-medium tracking-wide text-ink2" data-testid="hero-trust-badges">
          Sedan 2008
          <span aria-hidden="true" className="mx-2 text-line">|</span>
          F-skatt
          <span aria-hidden="true" className="mx-2 text-line">|</span>
          Ansvarsförsäkring
        </p>
      </div>
    </div>
  </section>
);
